import Vue from 'vue'

let user = Vue.ls.get('user')
/**
 * 是否是系统管理员
 * @returns {boolean}
 */
export const IsSysAdmin = () => {
  return !!user.roles['system.manage']
}

/**
 * 是否是抽取管理员
 * @returns {boolean}
 */
export const IsExpertExtractAdmin = () => {
  return !!user.roles['expert_extract_admin'] || IsSysAdmin()
}

/**
 * 是否是专家库管理员
 * @returns {boolean}
 */
export const IsExpertInfoAdmin = () => {
  return !!user.roles['expert_info_admin'] || IsSysAdmin()
}
